export default __webpack_public_path__ + "static/media/img-trabajo-1.44127de5.jpg";